// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file gd_platform.proto (package gd.v1, syntax proto3)
/* eslint-disable */

// Hosting: organisations, repositories, accounts, teams and tokens, and review (change requests,
// comments, approvals, protected branches). Repository-scoped calls on the other services name
// their repository with the `x-gd-repo: OWNER/NAME` request header; a call without it reaches
// the server's default repository, so single-repository servers and older clients are unchanged.

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "./gd_pb";
import { file_gd } from "./gd_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gd_platform.proto.
 */
export const file_gd_platform: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gd]);

/**
 * @generated from message gd.v1.Account
 */
export type Account = Message<"gd.v1.Account"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: gd.v1.AccountKind kind = 3;
   */
  kind: AccountKind;

  /**
   * Agents only: the person or team that owns the agent.
   *
   * @generated from field: string owner = 4;
   */
  owner: string;

  /**
   * @generated from field: string avatar_url = 5;
   */
  avatarUrl: string;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: bool site_admin = 7;
   */
  siteAdmin: boolean;

  /**
   * Agents: paused by their owner (reads only), and the only paths they may change (empty:
   * any path their role allows).
   *
   * @generated from field: bool paused = 8;
   */
  paused: boolean;

  /**
   * @generated from field: repeated string allowed_paths = 9;
   */
  allowedPaths: string[];

  /**
   * Agents: at most this many lands, and CI runs, a day (UTC); unset: no limit.
   *
   * @generated from field: optional uint32 lands_per_day = 10;
   */
  landsPerDay?: number | undefined;

  /**
   * @generated from field: optional uint32 runs_per_day = 11;
   */
  runsPerDay?: number | undefined;
};

/**
 * Describes the message gd.v1.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema: GenMessage<Account> = /*@__PURE__*/
  messageDesc(file_gd_platform, 0);

/**
 * Pauses or resumes an agent and keeps its changes to some paths; by its owner (or a server
 * administrator).
 *
 * @generated from message gd.v1.SetAgentControlsRequest
 */
export type SetAgentControlsRequest = Message<"gd.v1.SetAgentControlsRequest"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: bool paused = 2;
   */
  paused: boolean;

  /**
   * Path prefixes like `services/api` or `docs/`; empty for any path.
   *
   * @generated from field: repeated string allowed_paths = 3;
   */
  allowedPaths: string[];

  /**
   * Daily budgets (UTC days); unset: no limit. Over budget, the agent is refused and told why.
   *
   * @generated from field: optional uint32 lands_per_day = 4;
   */
  landsPerDay?: number | undefined;

  /**
   * @generated from field: optional uint32 runs_per_day = 5;
   */
  runsPerDay?: number | undefined;
};

/**
 * Describes the message gd.v1.SetAgentControlsRequest.
 * Use `create(SetAgentControlsRequestSchema)` to create a new message.
 */
export const SetAgentControlsRequestSchema: GenMessage<SetAgentControlsRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 1);

/**
 * Stops every agent writing to an organisation's repositories, whoever owns them (they keep
 * reading); its administrators'.
 *
 * @generated from message gd.v1.SetOrgAgentsPausedRequest
 */
export type SetOrgAgentsPausedRequest = Message<"gd.v1.SetOrgAgentsPausedRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: bool paused = 2;
   */
  paused: boolean;
};

/**
 * Describes the message gd.v1.SetOrgAgentsPausedRequest.
 * Use `create(SetOrgAgentsPausedRequestSchema)` to create a new message.
 */
export const SetOrgAgentsPausedRequestSchema: GenMessage<SetOrgAgentsPausedRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 2);

/**
 * @generated from message gd.v1.Repository
 */
export type Repository = Message<"gd.v1.Repository"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: gd.v1.Visibility visibility = 4;
   */
  visibility: Visibility;

  /**
   * @generated from field: string default_branch = 5;
   */
  defaultBranch: string;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * The caller's role, so the app shows only what the caller may do.
   *
   * @generated from field: gd.v1.Role viewer_role = 7;
   */
  viewerRole: Role;

  /**
   * @generated from field: bool archived = 8;
   */
  archived: boolean;

  /**
   * Activity in the last 24 hours, for lists.
   *
   * @generated from field: uint32 lands_24h = 9;
   */
  lands24h: number;

  /**
   * @generated from field: uint32 open_change_requests = 10;
   */
  openChangeRequests: number;

  /**
   * @generated from field: bytes tip = 11;
   */
  tip: Uint8Array;

  /**
   * @generated from field: int64 tip_at_ms = 12;
   */
  tipAtMs: bigint;

  /**
   * @generated from field: repeated string topics = 13;
   */
  topics: string[];

  /**
   * People who starred it; agents don't star.
   *
   * @generated from field: uint32 stars = 14;
   */
  stars: number;

  /**
   * @generated from field: bool viewer_starred = 15;
   */
  viewerStarred: boolean;

  /**
   * @generated from field: gd.v1.Watch viewer_watch = 16;
   */
  viewerWatch: Watch;

  /**
   * A fork: the repository it was forked from (empty when that's gone, or for others).
   *
   * @generated from field: gd.v1.RepositoryRef fork_of = 17;
   */
  forkOf?: RepositoryRef | undefined;

  /**
   * Forks of it the caller can read.
   *
   * @generated from field: uint32 forks = 18;
   */
  forks: number;
};

/**
 * Describes the message gd.v1.Repository.
 * Use `create(RepositorySchema)` to create a new message.
 */
export const RepositorySchema: GenMessage<Repository> = /*@__PURE__*/
  messageDesc(file_gd_platform, 3);

/**
 * @generated from message gd.v1.RepositoryRef
 */
export type RepositoryRef = Message<"gd.v1.RepositoryRef"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message gd.v1.RepositoryRef.
 * Use `create(RepositoryRefSchema)` to create a new message.
 */
export const RepositoryRefSchema: GenMessage<RepositoryRef> = /*@__PURE__*/
  messageDesc(file_gd_platform, 4);

/**
 * @generated from message gd.v1.ListRepositoriesRequest
 */
export type ListRepositoriesRequest = Message<"gd.v1.ListRepositoriesRequest"> & {
  /**
   * Empty: every repository the caller can read.
   *
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;

  /**
   * Only repositories the caller owns, belongs to (its organisation or a team) or was given
   * access to: not those it can read only because they are public or internal.
   *
   * @generated from field: bool involved = 5;
   */
  involved: boolean;
};

/**
 * Describes the message gd.v1.ListRepositoriesRequest.
 * Use `create(ListRepositoriesRequestSchema)` to create a new message.
 */
export const ListRepositoriesRequestSchema: GenMessage<ListRepositoriesRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 5);

/**
 * @generated from message gd.v1.ListRepositoriesResponse
 */
export type ListRepositoriesResponse = Message<"gd.v1.ListRepositoriesResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Repository repositories = 1;
   */
  repositories: Repository[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message gd.v1.ListRepositoriesResponse.
 * Use `create(ListRepositoriesResponseSchema)` to create a new message.
 */
export const ListRepositoriesResponseSchema: GenMessage<ListRepositoriesResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 6);

/**
 * @generated from message gd.v1.CreateRepositoryRequest
 */
export type CreateRepositoryRequest = Message<"gd.v1.CreateRepositoryRequest"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: gd.v1.Visibility visibility = 4;
   */
  visibility: Visibility;

  /**
   * @generated from field: string default_branch = 5;
   */
  defaultBranch: string;
};

/**
 * Describes the message gd.v1.CreateRepositoryRequest.
 * Use `create(CreateRepositoryRequestSchema)` to create a new message.
 */
export const CreateRepositoryRequestSchema: GenMessage<CreateRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 7);

/**
 * @generated from message gd.v1.UpdateRepositoryRequest
 */
export type UpdateRepositoryRequest = Message<"gd.v1.UpdateRepositoryRequest"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Only fields named in `fields` change (description, visibility, default_branch, archived, topics).
   *
   * @generated from field: repeated string fields = 3;
   */
  fields: string[];

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: gd.v1.Visibility visibility = 5;
   */
  visibility: Visibility;

  /**
   * @generated from field: string default_branch = 6;
   */
  defaultBranch: string;

  /**
   * @generated from field: bool archived = 7;
   */
  archived: boolean;

  /**
   * @generated from field: repeated string topics = 8;
   */
  topics: string[];
};

/**
 * Describes the message gd.v1.UpdateRepositoryRequest.
 * Use `create(UpdateRepositoryRequestSchema)` to create a new message.
 */
export const UpdateRepositoryRequestSchema: GenMessage<UpdateRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 8);

/**
 * Renames a repository, or moves it to another owner (an organisation you administer, or
 * your own account). Its history, issues, change requests, grants to people and tokens follow
 * it, and the old name answers with where it went. Needs admin access.
 *
 * @generated from message gd.v1.RenameRepositoryRequest
 */
export type RenameRepositoryRequest = Message<"gd.v1.RenameRepositoryRequest"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Empty: keep the name.
   *
   * @generated from field: string new_name = 3;
   */
  newName: string;

  /**
   * Empty: keep the owner. Moving drops grants to the old organisation's teams, and an
   * internal repository becomes private under a person.
   *
   * @generated from field: string new_owner = 4;
   */
  newOwner: string;
};

/**
 * Describes the message gd.v1.RenameRepositoryRequest.
 * Use `create(RenameRepositoryRequestSchema)` to create a new message.
 */
export const RenameRepositoryRequestSchema: GenMessage<RenameRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 9);

/**
 * Deletes a repository: it disappears at once and its name is free again. The server keeps
 * it, hidden, until an operator purges it, so a mistake can be undone. Needs admin access;
 * `confirm` must repeat OWNER/NAME.
 *
 * @generated from message gd.v1.DeleteRepositoryRequest
 */
export type DeleteRepositoryRequest = Message<"gd.v1.DeleteRepositoryRequest"> & {
  /**
   * @generated from field: string owner = 1;
   */
  owner: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string confirm = 3;
   */
  confirm: string;
};

/**
 * Describes the message gd.v1.DeleteRepositoryRequest.
 * Use `create(DeleteRepositoryRequestSchema)` to create a new message.
 */
export const DeleteRepositoryRequestSchema: GenMessage<DeleteRepositoryRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 10);

/**
 * @generated from message gd.v1.Organization
 */
export type Organization = Message<"gd.v1.Organization"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: int64 created_at_ms = 4;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: gd.v1.Role viewer_role = 5;
   */
  viewerRole: Role;

  /**
   * @generated from field: uint32 repositories = 6;
   */
  repositories: number;

  /**
   * People who are members.
   *
   * @generated from field: uint32 members = 7;
   */
  members: number;

  /**
   * Agents that are members or landed a change here this month.
   *
   * @generated from field: uint32 agents = 8;
   */
  agents: number;

  /**
   * Can read but not write (ADR-035); every page of the organisation says so.
   *
   * @generated from field: bool suspended = 9;
   */
  suspended: boolean;
};

/**
 * Describes the message gd.v1.Organization.
 * Use `create(OrganizationSchema)` to create a new message.
 */
export const OrganizationSchema: GenMessage<Organization> = /*@__PURE__*/
  messageDesc(file_gd_platform, 11);

/**
 * @generated from message gd.v1.Member
 */
export type Member = Message<"gd.v1.Member"> & {
  /**
   * @generated from field: gd.v1.Account account = 1;
   */
  account?: Account | undefined;

  /**
   * @generated from field: gd.v1.Role role = 2;
   */
  role: Role;

  /**
   * @generated from field: repeated string teams = 3;
   */
  teams: string[];

  /**
   * The address they sign in with; only to members of the organisation, so people with the
   * same name can be told apart.
   *
   * @generated from field: string email = 4;
   */
  email: string;
};

/**
 * Describes the message gd.v1.Member.
 * Use `create(MemberSchema)` to create a new message.
 */
export const MemberSchema: GenMessage<Member> = /*@__PURE__*/
  messageDesc(file_gd_platform, 12);

/**
 * @generated from message gd.v1.Team
 */
export type Team = Message<"gd.v1.Team"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated string members = 5;
   */
  members: string[];
};

/**
 * Describes the message gd.v1.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/
  messageDesc(file_gd_platform, 13);

/**
 * @generated from message gd.v1.Grant
 */
export type Grant = Message<"gd.v1.Grant"> & {
  /**
   * A person, agent or team ("org/team-slug").
   *
   * @generated from field: string principal = 1;
   */
  principal: string;

  /**
   * @generated from field: gd.v1.Role role = 2;
   */
  role: Role;
};

/**
 * Describes the message gd.v1.Grant.
 * Use `create(GrantSchema)` to create a new message.
 */
export const GrantSchema: GenMessage<Grant> = /*@__PURE__*/
  messageDesc(file_gd_platform, 14);

/**
 * @generated from message gd.v1.OrgName
 */
export type OrgName = Message<"gd.v1.OrgName"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;
};

/**
 * Describes the message gd.v1.OrgName.
 * Use `create(OrgNameSchema)` to create a new message.
 */
export const OrgNameSchema: GenMessage<OrgName> = /*@__PURE__*/
  messageDesc(file_gd_platform, 15);

/**
 * @generated from message gd.v1.ListOrganizationsResponse
 */
export type ListOrganizationsResponse = Message<"gd.v1.ListOrganizationsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Organization organizations = 1;
   */
  organizations: Organization[];
};

/**
 * Describes the message gd.v1.ListOrganizationsResponse.
 * Use `create(ListOrganizationsResponseSchema)` to create a new message.
 */
export const ListOrganizationsResponseSchema: GenMessage<ListOrganizationsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 16);

/**
 * @generated from message gd.v1.CreateOrganizationRequest
 */
export type CreateOrganizationRequest = Message<"gd.v1.CreateOrganizationRequest"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message gd.v1.CreateOrganizationRequest.
 * Use `create(CreateOrganizationRequestSchema)` to create a new message.
 */
export const CreateOrganizationRequestSchema: GenMessage<CreateOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 17);

/**
 * @generated from message gd.v1.ListMembersResponse
 */
export type ListMembersResponse = Message<"gd.v1.ListMembersResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Member members = 1;
   */
  members: Member[];
};

/**
 * Describes the message gd.v1.ListMembersResponse.
 * Use `create(ListMembersResponseSchema)` to create a new message.
 */
export const ListMembersResponseSchema: GenMessage<ListMembersResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 18);

/**
 * @generated from message gd.v1.SetMemberRequest
 */
export type SetMemberRequest = Message<"gd.v1.SetMemberRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: string login = 2;
   */
  login: string;

  /**
   * ROLE_UNSPECIFIED removes the member.
   *
   * @generated from field: gd.v1.Role role = 3;
   */
  role: Role;
};

/**
 * Describes the message gd.v1.SetMemberRequest.
 * Use `create(SetMemberRequestSchema)` to create a new message.
 */
export const SetMemberRequestSchema: GenMessage<SetMemberRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 19);

/**
 * @generated from message gd.v1.ListTeamsResponse
 */
export type ListTeamsResponse = Message<"gd.v1.ListTeamsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Team teams = 1;
   */
  teams: Team[];
};

/**
 * Describes the message gd.v1.ListTeamsResponse.
 * Use `create(ListTeamsResponseSchema)` to create a new message.
 */
export const ListTeamsResponseSchema: GenMessage<ListTeamsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 20);

/**
 * @generated from message gd.v1.TeamRef
 */
export type TeamRef = Message<"gd.v1.TeamRef"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;
};

/**
 * Describes the message gd.v1.TeamRef.
 * Use `create(TeamRefSchema)` to create a new message.
 */
export const TeamRefSchema: GenMessage<TeamRef> = /*@__PURE__*/
  messageDesc(file_gd_platform, 21);

/**
 * @generated from message gd.v1.ListGrantsResponse
 */
export type ListGrantsResponse = Message<"gd.v1.ListGrantsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Grant grants = 1;
   */
  grants: Grant[];
};

/**
 * Describes the message gd.v1.ListGrantsResponse.
 * Use `create(ListGrantsResponseSchema)` to create a new message.
 */
export const ListGrantsResponseSchema: GenMessage<ListGrantsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 22);

/**
 * @generated from message gd.v1.SetGrantRequest
 */
export type SetGrantRequest = Message<"gd.v1.SetGrantRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: string principal = 2;
   */
  principal: string;

  /**
   * ROLE_UNSPECIFIED removes the grant.
   *
   * @generated from field: gd.v1.Role role = 3;
   */
  role: Role;
};

/**
 * Describes the message gd.v1.SetGrantRequest.
 * Use `create(SetGrantRequestSchema)` to create a new message.
 */
export const SetGrantRequestSchema: GenMessage<SetGrantRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 23);

/**
 * @generated from message gd.v1.Token
 */
export type Token = Message<"gd.v1.Token"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * For agent tokens, the agent the token acts as.
   *
   * @generated from field: string acts_as = 3;
   */
  actsAs: string;

  /**
   * @generated from field: repeated string repositories = 4;
   */
  repositories: string[];

  /**
   * @generated from field: gd.v1.Role max_role = 5;
   */
  maxRole: Role;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: int64 expires_at_ms = 7;
   */
  expiresAtMs: bigint;

  /**
   * @generated from field: int64 last_used_at_ms = 8;
   */
  lastUsedAtMs: bigint;
};

/**
 * Describes the message gd.v1.Token.
 * Use `create(TokenSchema)` to create a new message.
 */
export const TokenSchema: GenMessage<Token> = /*@__PURE__*/
  messageDesc(file_gd_platform, 24);

/**
 * @generated from message gd.v1.ListTokensResponse
 */
export type ListTokensResponse = Message<"gd.v1.ListTokensResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Token tokens = 1;
   */
  tokens: Token[];
};

/**
 * Describes the message gd.v1.ListTokensResponse.
 * Use `create(ListTokensResponseSchema)` to create a new message.
 */
export const ListTokensResponseSchema: GenMessage<ListTokensResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 25);

/**
 * @generated from message gd.v1.CreateTokenRequest
 */
export type CreateTokenRequest = Message<"gd.v1.CreateTokenRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string acts_as = 2;
   */
  actsAs: string;

  /**
   * OWNER/NAME, or OWNER/* for every repository of an organisation you belong to (made later
   * too). Empty: every repository you can reach.
   *
   * @generated from field: repeated string repositories = 3;
   */
  repositories: string[];

  /**
   * @generated from field: gd.v1.Role max_role = 4;
   */
  maxRole: Role;

  /**
   * @generated from field: int64 expires_at_ms = 5;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message gd.v1.CreateTokenRequest.
 * Use `create(CreateTokenRequestSchema)` to create a new message.
 */
export const CreateTokenRequestSchema: GenMessage<CreateTokenRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 26);

/**
 * @generated from message gd.v1.CreateTokenResponse
 */
export type CreateTokenResponse = Message<"gd.v1.CreateTokenResponse"> & {
  /**
   * @generated from field: gd.v1.Token token = 1;
   */
  token?: Token | undefined;

  /**
   * Shown once; the server keeps only a hash.
   *
   * @generated from field: string secret = 2;
   */
  secret: string;
};

/**
 * Describes the message gd.v1.CreateTokenResponse.
 * Use `create(CreateTokenResponseSchema)` to create a new message.
 */
export const CreateTokenResponseSchema: GenMessage<CreateTokenResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 27);

/**
 * @generated from message gd.v1.RevokeTokenRequest
 */
export type RevokeTokenRequest = Message<"gd.v1.RevokeTokenRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gd.v1.RevokeTokenRequest.
 * Use `create(RevokeTokenRequestSchema)` to create a new message.
 */
export const RevokeTokenRequestSchema: GenMessage<RevokeTokenRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 28);

/**
 * Calls a URL when something happens in a repository. Events: push, change_request, review,
 * comment, check (and ping). Bodies are JSON, signed like GitHub's: the
 * `X-Grovedock-Signature-256` header is `sha256=` and the hex HMAC-SHA256 of the body.
 *
 * @generated from message gd.v1.Webhook
 */
export type Webhook = Message<"gd.v1.Webhook"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gd.v1.RepositoryRef repository = 2;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: string url = 3;
   */
  url: string;

  /**
   * Empty: every event.
   *
   * @generated from field: repeated string events = 4;
   */
  events: string[];

  /**
   * @generated from field: bool active = 5;
   */
  active: boolean;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: string created_by = 7;
   */
  createdBy: string;

  /**
   * The last delivery's HTTP status (0: none yet, -1: no answer).
   *
   * @generated from field: int32 last_status = 8;
   */
  lastStatus: number;

  /**
   * @generated from field: int64 last_delivery_at_ms = 9;
   */
  lastDeliveryAtMs: bigint;
};

/**
 * Describes the message gd.v1.Webhook.
 * Use `create(WebhookSchema)` to create a new message.
 */
export const WebhookSchema: GenMessage<Webhook> = /*@__PURE__*/
  messageDesc(file_gd_platform, 29);

/**
 * @generated from message gd.v1.CreateWebhookRequest
 */
export type CreateWebhookRequest = Message<"gd.v1.CreateWebhookRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: repeated string events = 3;
   */
  events: string[];

  /**
   * Empty: the server makes one and returns it once.
   *
   * @generated from field: string secret = 4;
   */
  secret: string;
};

/**
 * Describes the message gd.v1.CreateWebhookRequest.
 * Use `create(CreateWebhookRequestSchema)` to create a new message.
 */
export const CreateWebhookRequestSchema: GenMessage<CreateWebhookRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 30);

/**
 * @generated from message gd.v1.CreateWebhookResponse
 */
export type CreateWebhookResponse = Message<"gd.v1.CreateWebhookResponse"> & {
  /**
   * @generated from field: gd.v1.Webhook webhook = 1;
   */
  webhook?: Webhook | undefined;

  /**
   * @generated from field: string secret = 2;
   */
  secret: string;
};

/**
 * Describes the message gd.v1.CreateWebhookResponse.
 * Use `create(CreateWebhookResponseSchema)` to create a new message.
 */
export const CreateWebhookResponseSchema: GenMessage<CreateWebhookResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 31);

/**
 * @generated from message gd.v1.WebhookRef
 */
export type WebhookRef = Message<"gd.v1.WebhookRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message gd.v1.WebhookRef.
 * Use `create(WebhookRefSchema)` to create a new message.
 */
export const WebhookRefSchema: GenMessage<WebhookRef> = /*@__PURE__*/
  messageDesc(file_gd_platform, 32);

/**
 * @generated from message gd.v1.ListWebhooksResponse
 */
export type ListWebhooksResponse = Message<"gd.v1.ListWebhooksResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Webhook webhooks = 1;
   */
  webhooks: Webhook[];
};

/**
 * Describes the message gd.v1.ListWebhooksResponse.
 * Use `create(ListWebhooksResponseSchema)` to create a new message.
 */
export const ListWebhooksResponseSchema: GenMessage<ListWebhooksResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 33);

/**
 * @generated from message gd.v1.WebhookDelivery
 */
export type WebhookDelivery = Message<"gd.v1.WebhookDelivery"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string event = 2;
   */
  event: string;

  /**
   * HTTP status of the last attempt (0: not tried yet, -1: no answer).
   *
   * @generated from field: int32 status = 3;
   */
  status: number;

  /**
   * @generated from field: string error = 4;
   */
  error: string;

  /**
   * @generated from field: uint32 attempts = 5;
   */
  attempts: number;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: bool delivered = 7;
   */
  delivered: boolean;

  /**
   * @generated from field: string payload = 8;
   */
  payload: string;
};

/**
 * Describes the message gd.v1.WebhookDelivery.
 * Use `create(WebhookDeliverySchema)` to create a new message.
 */
export const WebhookDeliverySchema: GenMessage<WebhookDelivery> = /*@__PURE__*/
  messageDesc(file_gd_platform, 34);

/**
 * @generated from message gd.v1.ListWebhookDeliveriesResponse
 */
export type ListWebhookDeliveriesResponse = Message<"gd.v1.ListWebhookDeliveriesResponse"> & {
  /**
   * @generated from field: repeated gd.v1.WebhookDelivery deliveries = 1;
   */
  deliveries: WebhookDelivery[];
};

/**
 * Describes the message gd.v1.ListWebhookDeliveriesResponse.
 * Use `create(ListWebhookDeliveriesResponseSchema)` to create a new message.
 */
export const ListWebhookDeliveriesResponseSchema: GenMessage<ListWebhookDeliveriesResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 35);

/**
 * @generated from message gd.v1.LinkIdentityRequest
 */
export type LinkIdentityRequest = Message<"gd.v1.LinkIdentityRequest"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * `email`, or the id of a configured sign-in provider such as `google`.
   *
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * The email address, or the provider's `sub` for the person.
   *
   * @generated from field: string subject = 3;
   */
  subject: string;
};

/**
 * Describes the message gd.v1.LinkIdentityRequest.
 * Use `create(LinkIdentityRequestSchema)` to create a new message.
 */
export const LinkIdentityRequestSchema: GenMessage<LinkIdentityRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 36);

/**
 * @generated from message gd.v1.ViewerResponse
 */
export type ViewerResponse = Message<"gd.v1.ViewerResponse"> & {
  /**
   * @generated from field: gd.v1.Account account = 1;
   */
  account?: Account | undefined;

  /**
   * @generated from field: repeated gd.v1.Organization organizations = 2;
   */
  organizations: Organization[];

  /**
   * The platform token making the call, if one is: revoke it to sign out.
   *
   * @generated from field: string token_id = 3;
   */
  tokenId: string;
};

/**
 * Describes the message gd.v1.ViewerResponse.
 * Use `create(ViewerResponseSchema)` to create a new message.
 */
export const ViewerResponseSchema: GenMessage<ViewerResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 37);

/**
 * @generated from message gd.v1.Check
 */
export type Check = Message<"gd.v1.Check"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: gd.v1.CheckState state = 2;
   */
  state: CheckState;

  /**
   * @generated from field: string summary = 3;
   */
  summary: string;

  /**
   * @generated from field: string details_url = 4;
   */
  detailsUrl: string;

  /**
   * @generated from field: int64 started_at_ms = 5;
   */
  startedAtMs: bigint;

  /**
   * @generated from field: int64 finished_at_ms = 6;
   */
  finishedAtMs: bigint;
};

/**
 * Describes the message gd.v1.Check.
 * Use `create(CheckSchema)` to create a new message.
 */
export const CheckSchema: GenMessage<Check> = /*@__PURE__*/
  messageDesc(file_gd_platform, 38);

/**
 * @generated from message gd.v1.ReviewSummary
 */
export type ReviewSummary = Message<"gd.v1.ReviewSummary"> & {
  /**
   * @generated from field: string reviewer = 1;
   */
  reviewer: string;

  /**
   * @generated from field: gd.v1.Verdict verdict = 2;
   */
  verdict: Verdict;

  /**
   * @generated from field: int64 at_ms = 3;
   */
  atMs: bigint;

  /**
   * The source tip the reviewer looked at; a newer tip makes the review stale.
   *
   * @generated from field: bytes reviewed_tip = 4;
   */
  reviewedTip: Uint8Array;
};

/**
 * Describes the message gd.v1.ReviewSummary.
 * Use `create(ReviewSummarySchema)` to create a new message.
 */
export const ReviewSummarySchema: GenMessage<ReviewSummary> = /*@__PURE__*/
  messageDesc(file_gd_platform, 39);

/**
 * @generated from message gd.v1.ChangeRequest
 */
export type ChangeRequest = Message<"gd.v1.ChangeRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: uint64 number = 2;
   */
  number: bigint;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string author = 5;
   */
  author: string;

  /**
   * @generated from field: gd.v1.ChangeRequestState state = 6;
   */
  state: ChangeRequestState;

  /**
   * @generated from field: string source = 7;
   */
  source: string;

  /**
   * @generated from field: string target = 8;
   */
  target: string;

  /**
   * @generated from field: bytes source_tip = 9;
   */
  sourceTip: Uint8Array;

  /**
   * @generated from field: bytes base = 10;
   */
  base: Uint8Array;

  /**
   * @generated from field: int64 created_at_ms = 11;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: int64 updated_at_ms = 12;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: repeated string requested_reviewers = 13;
   */
  requestedReviewers: string[];

  /**
   * @generated from field: repeated gd.v1.ReviewSummary reviews = 14;
   */
  reviews: ReviewSummary[];

  /**
   * @generated from field: repeated gd.v1.Check checks = 15;
   */
  checks: Check[];

  /**
   * @generated from field: uint32 comments = 16;
   */
  comments: number;

  /**
   * @generated from field: uint32 files = 17;
   */
  files: number;

  /**
   * @generated from field: uint32 additions = 18;
   */
  additions: number;

  /**
   * @generated from field: uint32 deletions = 19;
   */
  deletions: number;

  /**
   * Files whose edits clash with changes landed on the target since `base` (files both changed
   * whose edits combine line by line aren't listed: landing merges them).
   *
   * @generated from field: repeated string conflicts = 20;
   */
  conflicts: string[];

  /**
   * Why it cannot land yet, in words ("needs 1 more approval"); empty when it can.
   *
   * @generated from field: repeated string blockers = 21;
   */
  blockers: string[];

  /**
   * @generated from field: bytes landed_as = 22;
   */
  landedAs: Uint8Array;

  /**
   * @generated from field: repeated string labels = 23;
   */
  labels: string[];

  /**
   * Opened automatically when an agent landed on a protected branch.
   *
   * @generated from field: bool from_protected_land = 24;
   */
  fromProtectedLand: boolean;

  /**
   * Issues and change requests that mention it (#12); filled in when one is read.
   *
   * @generated from field: repeated uint64 referenced_by = 25;
   */
  referencedBy: bigint[];

  /**
   * @generated from field: uint64 milestone = 26;
   */
  milestone: bigint;

  /**
   * From a fork: the repository `source` is a branch of. Empty: a branch of this repository.
   *
   * @generated from field: gd.v1.RepositoryRef source_repository = 27;
   */
  sourceRepository?: RepositoryRef | undefined;

  /**
   * Lands by itself once nothing blocks it, as this person (or agent); empty: off.
   *
   * @generated from field: string land_when_ready_by = 28;
   */
  landWhenReadyBy: string;

  /**
   * Where landing by itself has got to, in words ("testing the result on main: run #12");
   * empty when it isn't under way.
   *
   * @generated from field: string landing = 29;
   */
  landing: string;
};

/**
 * Describes the message gd.v1.ChangeRequest.
 * Use `create(ChangeRequestSchema)` to create a new message.
 */
export const ChangeRequestSchema: GenMessage<ChangeRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 40);

/**
 * @generated from message gd.v1.ListChangeRequestsRequest
 */
export type ListChangeRequestsRequest = Message<"gd.v1.ListChangeRequestsRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * Empty: all states.
   *
   * @generated from field: repeated gd.v1.ChangeRequestState states = 2;
   */
  states: ChangeRequestState[];

  /**
   * @generated from field: string author = 3;
   */
  author: string;

  /**
   * @generated from field: string reviewer = 4;
   */
  reviewer: string;

  /**
   * Search syntax: words in the title, branch or author, `#12`, and `is:open` (drafts too),
   * `is:draft`, `is:landed`, `is:closed`, `is:ready`, `is:blocked`, `is:attention`,
   * `author:` (`*` and `@me`), `reviewer:`, `into:`, `from:`, `label:`; `-key:value` excludes.
   * No state named (here or in `states`): every state.
   *
   * @generated from field: string query = 5;
   */
  query: string;

  /**
   * @generated from field: uint32 limit = 6;
   */
  limit: number;

  /**
   * @generated from field: string page_token = 7;
   */
  pageToken: string;

  /**
   * newest (default), oldest, updated, largest.
   *
   * @generated from field: string sort = 8;
   */
  sort: string;
};

/**
 * Describes the message gd.v1.ListChangeRequestsRequest.
 * Use `create(ListChangeRequestsRequestSchema)` to create a new message.
 */
export const ListChangeRequestsRequestSchema: GenMessage<ListChangeRequestsRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 41);

/**
 * @generated from message gd.v1.ListChangeRequestsResponse
 */
export type ListChangeRequestsResponse = Message<"gd.v1.ListChangeRequestsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.ChangeRequest change_requests = 1;
   */
  changeRequests: ChangeRequest[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: uint64 total = 3;
   */
  total: bigint;
};

/**
 * Describes the message gd.v1.ListChangeRequestsResponse.
 * Use `create(ListChangeRequestsResponseSchema)` to create a new message.
 */
export const ListChangeRequestsResponseSchema: GenMessage<ListChangeRequestsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 42);

/**
 * @generated from message gd.v1.ChangeRequestRef
 */
export type ChangeRequestRef = Message<"gd.v1.ChangeRequestRef"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: uint64 number = 2;
   */
  number: bigint;
};

/**
 * Describes the message gd.v1.ChangeRequestRef.
 * Use `create(ChangeRequestRefSchema)` to create a new message.
 */
export const ChangeRequestRefSchema: GenMessage<ChangeRequestRef> = /*@__PURE__*/
  messageDesc(file_gd_platform, 43);

/**
 * @generated from message gd.v1.CreateChangeRequestRequest
 */
export type CreateChangeRequestRequest = Message<"gd.v1.CreateChangeRequestRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: string target = 3;
   */
  target: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * @generated from field: bool draft = 6;
   */
  draft: boolean;

  /**
   * @generated from field: repeated string reviewers = 7;
   */
  reviewers: string[];

  /**
   * @generated from field: uint64 milestone = 8;
   */
  milestone: bigint;

  /**
   * To propose a fork's branch: the fork (of this repository, at any depth). Reading this
   * repository is then enough to open one; landing it still takes Write here.
   *
   * @generated from field: gd.v1.RepositoryRef source_repository = 9;
   */
  sourceRepository?: RepositoryRef | undefined;
};

/**
 * Describes the message gd.v1.CreateChangeRequestRequest.
 * Use `create(CreateChangeRequestRequestSchema)` to create a new message.
 */
export const CreateChangeRequestRequestSchema: GenMessage<CreateChangeRequestRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 44);

/**
 * @generated from message gd.v1.UpdateChangeRequestRequest
 */
export type UpdateChangeRequestRequest = Message<"gd.v1.UpdateChangeRequestRequest"> & {
  /**
   * @generated from field: gd.v1.ChangeRequestRef ref = 1;
   */
  ref?: ChangeRequestRef | undefined;

  /**
   * @generated from field: repeated string fields = 2;
   */
  fields: string[];

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: gd.v1.ChangeRequestState state = 5;
   */
  state: ChangeRequestState;

  /**
   * @generated from field: repeated string reviewers = 6;
   */
  reviewers: string[];

  /**
   * @generated from field: repeated string labels = 7;
   */
  labels: string[];

  /**
   * @generated from field: uint64 milestone = 8;
   */
  milestone: bigint;
};

/**
 * Describes the message gd.v1.UpdateChangeRequestRequest.
 * Use `create(UpdateChangeRequestRequestSchema)` to create a new message.
 */
export const UpdateChangeRequestRequestSchema: GenMessage<UpdateChangeRequestRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 45);

/**
 * @generated from message gd.v1.Comment
 */
export type Comment = Message<"gd.v1.Comment"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string author = 2;
   */
  author: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: int64 created_at_ms = 4;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: int64 edited_at_ms = 5;
   */
  editedAtMs: bigint;

  /**
   * Line comments: the file, line and side they are attached to, and the tip they were made on.
   *
   * @generated from field: string path = 6;
   */
  path: string;

  /**
   * @generated from field: uint32 line = 7;
   */
  line: number;

  /**
   * @generated from field: bool on_base = 8;
   */
  onBase: boolean;

  /**
   * @generated from field: bytes at_tip = 9;
   */
  atTip: Uint8Array;

  /**
   * Replies name the first comment of their thread.
   *
   * @generated from field: string thread = 10;
   */
  thread: string;

  /**
   * @generated from field: bool resolved = 11;
   */
  resolved: boolean;

  /**
   * A suggested replacement for the commented lines, which the author can apply.
   *
   * @generated from field: string suggestion = 12;
   */
  suggestion: string;

  /**
   * @generated from field: uint32 end_line = 13;
   */
  endLine: number;
};

/**
 * Describes the message gd.v1.Comment.
 * Use `create(CommentSchema)` to create a new message.
 */
export const CommentSchema: GenMessage<Comment> = /*@__PURE__*/
  messageDesc(file_gd_platform, 46);

/**
 * @generated from message gd.v1.ListCommentsResponse
 */
export type ListCommentsResponse = Message<"gd.v1.ListCommentsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Comment comments = 1;
   */
  comments: Comment[];
};

/**
 * Describes the message gd.v1.ListCommentsResponse.
 * Use `create(ListCommentsResponseSchema)` to create a new message.
 */
export const ListCommentsResponseSchema: GenMessage<ListCommentsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 47);

/**
 * @generated from message gd.v1.AddCommentRequest
 */
export type AddCommentRequest = Message<"gd.v1.AddCommentRequest"> & {
  /**
   * @generated from field: gd.v1.ChangeRequestRef ref = 1;
   */
  ref?: ChangeRequestRef | undefined;

  /**
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * @generated from field: uint32 line = 4;
   */
  line: number;

  /**
   * @generated from field: uint32 end_line = 5;
   */
  endLine: number;

  /**
   * @generated from field: bool on_base = 6;
   */
  onBase: boolean;

  /**
   * @generated from field: string thread = 7;
   */
  thread: string;

  /**
   * @generated from field: string suggestion = 8;
   */
  suggestion: string;
};

/**
 * Describes the message gd.v1.AddCommentRequest.
 * Use `create(AddCommentRequestSchema)` to create a new message.
 */
export const AddCommentRequestSchema: GenMessage<AddCommentRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 48);

/**
 * Changes a comment's text, or deletes it with an empty body. Its author (or the person an
 * agent author answers to) may do either; a repository administrator may also delete. A deleted
 * comment keeps its place in its thread, with no text.
 *
 * @generated from message gd.v1.EditCommentRequest
 */
export type EditCommentRequest = Message<"gd.v1.EditCommentRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * The change request or issue the comment is on.
   *
   * @generated from field: uint64 number = 2;
   */
  number: bigint;

  /**
   * @generated from field: string id = 3;
   */
  id: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;
};

/**
 * Describes the message gd.v1.EditCommentRequest.
 * Use `create(EditCommentRequestSchema)` to create a new message.
 */
export const EditCommentRequestSchema: GenMessage<EditCommentRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 49);

/**
 * @generated from message gd.v1.ResolveThreadRequest
 */
export type ResolveThreadRequest = Message<"gd.v1.ResolveThreadRequest"> & {
  /**
   * @generated from field: gd.v1.ChangeRequestRef ref = 1;
   */
  ref?: ChangeRequestRef | undefined;

  /**
   * @generated from field: string thread = 2;
   */
  thread: string;

  /**
   * @generated from field: bool resolved = 3;
   */
  resolved: boolean;
};

/**
 * Describes the message gd.v1.ResolveThreadRequest.
 * Use `create(ResolveThreadRequestSchema)` to create a new message.
 */
export const ResolveThreadRequestSchema: GenMessage<ResolveThreadRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 50);

/**
 * @generated from message gd.v1.SubmitReviewRequest
 */
export type SubmitReviewRequest = Message<"gd.v1.SubmitReviewRequest"> & {
  /**
   * @generated from field: gd.v1.ChangeRequestRef ref = 1;
   */
  ref?: ChangeRequestRef | undefined;

  /**
   * @generated from field: gd.v1.Verdict verdict = 2;
   */
  verdict: Verdict;

  /**
   * @generated from field: string body = 3;
   */
  body: string;
};

/**
 * Describes the message gd.v1.SubmitReviewRequest.
 * Use `create(SubmitReviewRequestSchema)` to create a new message.
 */
export const SubmitReviewRequestSchema: GenMessage<SubmitReviewRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 51);

/**
 * @generated from message gd.v1.LandChangeRequestResponse
 */
export type LandChangeRequestResponse = Message<"gd.v1.LandChangeRequestResponse"> & {
  /**
   * @generated from field: gd.v1.ChangeRequest change_request = 1;
   */
  changeRequest?: ChangeRequest | undefined;

  /**
   * @generated from field: bytes landed_as = 2;
   */
  landedAs: Uint8Array;
};

/**
 * Describes the message gd.v1.LandChangeRequestResponse.
 * Use `create(LandChangeRequestResponseSchema)` to create a new message.
 */
export const LandChangeRequestResponseSchema: GenMessage<LandChangeRequestResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 52);

/**
 * @generated from message gd.v1.Protection
 */
export type Protection = Message<"gd.v1.Protection"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * A branch name or pattern (`main`, `release/*`).
   *
   * @generated from field: string pattern = 2;
   */
  pattern: string;

  /**
   * @generated from field: uint32 required_approvals = 3;
   */
  requiredApprovals: number;

  /**
   * @generated from field: repeated string required_checks = 4;
   */
  requiredChecks: string[];

  /**
   * Approvals go stale when the source changes.
   *
   * @generated from field: bool dismiss_stale = 5;
   */
  dismissStale: boolean;

  /**
   * Agents may land directly; otherwise their land opens a change request.
   *
   * @generated from field: bool agents_land_directly = 6;
   */
  agentsLandDirectly: boolean;

  /**
   * Who may land without review (admins, a team, a person).
   *
   * @generated from field: repeated string bypass = 7;
   */
  bypass: string[];

  /**
   * Stricter review where it matters: e.g. two people must approve when an agent changes auth/.
   *
   * @generated from field: repeated gd.v1.ReviewRule rules = 8;
   */
  rules: ReviewRule[];

  /**
   * A change request landing here by itself is first built on the branch's current tip and
   * tested (Runs); the branch moves to exactly what passed, or not at all.
   *
   * @generated from field: bool test_before_landing = 9;
   */
  testBeforeLanding: boolean;
};

/**
 * Describes the message gd.v1.Protection.
 * Use `create(ProtectionSchema)` to create a new message.
 */
export const ProtectionSchema: GenMessage<Protection> = /*@__PURE__*/
  messageDesc(file_gd_platform, 53);

/**
 * A review rule: when a change request touches `paths` (and, with `agents_only`, an agent
 * opened it), it needs `human_approvals` approvals from people. Agents' approvals don't count.
 *
 * @generated from message gd.v1.ReviewRule
 */
export type ReviewRule = Message<"gd.v1.ReviewRule"> & {
  /**
   * Folders it covers, like `auth` or `services/billing`; empty: every path.
   *
   * @generated from field: repeated string paths = 1;
   */
  paths: string[];

  /**
   * @generated from field: bool agents_only = 2;
   */
  agentsOnly: boolean;

  /**
   * @generated from field: uint32 human_approvals = 3;
   */
  humanApprovals: number;
};

/**
 * Describes the message gd.v1.ReviewRule.
 * Use `create(ReviewRuleSchema)` to create a new message.
 */
export const ReviewRuleSchema: GenMessage<ReviewRule> = /*@__PURE__*/
  messageDesc(file_gd_platform, 54);

/**
 * @generated from message gd.v1.ListProtectionsResponse
 */
export type ListProtectionsResponse = Message<"gd.v1.ListProtectionsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Protection protections = 1;
   */
  protections: Protection[];
};

/**
 * Describes the message gd.v1.ListProtectionsResponse.
 * Use `create(ListProtectionsResponseSchema)` to create a new message.
 */
export const ListProtectionsResponseSchema: GenMessage<ListProtectionsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 55);

/**
 * @generated from message gd.v1.ProtectionRef
 */
export type ProtectionRef = Message<"gd.v1.ProtectionRef"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: string pattern = 2;
   */
  pattern: string;
};

/**
 * Describes the message gd.v1.ProtectionRef.
 * Use `create(ProtectionRefSchema)` to create a new message.
 */
export const ProtectionRefSchema: GenMessage<ProtectionRef> = /*@__PURE__*/
  messageDesc(file_gd_platform, 56);

/**
 * A CI result for the change request's current version; a new version starts with none.
 *
 * @generated from message gd.v1.ReportCheckRequest
 */
export type ReportCheckRequest = Message<"gd.v1.ReportCheckRequest"> & {
  /**
   * @generated from field: gd.v1.ChangeRequestRef ref = 1;
   */
  ref?: ChangeRequestRef | undefined;

  /**
   * @generated from field: gd.v1.Check check = 2;
   */
  check?: Check | undefined;
};

/**
 * Describes the message gd.v1.ReportCheckRequest.
 * Use `create(ReportCheckRequestSchema)` to create a new message.
 */
export const ReportCheckRequestSchema: GenMessage<ReportCheckRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 57);

/**
 * @generated from message gd.v1.Event
 */
export type Event = Message<"gd.v1.Event"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gd.v1.EventKind kind = 2;
   */
  kind: EventKind;

  /**
   * @generated from field: string actor = 3;
   */
  actor: string;

  /**
   * @generated from field: gd.v1.RepositoryRef repository = 4;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: int64 at_ms = 5;
   */
  atMs: bigint;

  /**
   * @generated from field: uint64 change_request = 6;
   */
  changeRequest: bigint;

  /**
   * @generated from field: bytes changeset = 7;
   */
  changeset: Uint8Array;

  /**
   * @generated from field: string summary = 8;
   */
  summary: string;

  /**
   * The issue's or change request's title (`change_request` names it), filled when listed.
   *
   * @generated from field: string title = 9;
   */
  title: string;
};

/**
 * Describes the message gd.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_gd_platform, 58);

/**
 * @generated from message gd.v1.InboxRequest
 */
export type InboxRequest = Message<"gd.v1.InboxRequest"> & {
  /**
   * @generated from field: uint32 limit = 1;
   */
  limit: number;
};

/**
 * Describes the message gd.v1.InboxRequest.
 * Use `create(InboxRequestSchema)` to create a new message.
 */
export const InboxRequestSchema: GenMessage<InboxRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 59);

/**
 * @generated from message gd.v1.InboxItem
 */
export type InboxItem = Message<"gd.v1.InboxItem"> & {
  /**
   * One of: a change request, an issue assigned to you, or a note (a mention, an agent of yours
   * in trouble).
   *
   * @generated from field: gd.v1.ChangeRequest change_request = 1;
   */
  changeRequest?: ChangeRequest | undefined;

  /**
   * @generated from field: gd.v1.Issue issue = 4;
   */
  issue?: Issue | undefined;

  /**
   * @generated from field: gd.v1.InboxNote note = 5;
   */
  note?: InboxNote | undefined;

  /**
   * Why it is in the inbox: "review requested", "changes requested on yours", "agent waiting".
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: bool unread = 3;
   */
  unread: boolean;

  /**
   * For a change request or an issue: the latest thing someone else did on it.
   *
   * @generated from field: gd.v1.Event latest = 6;
   */
  latest?: Event | undefined;
};

/**
 * Describes the message gd.v1.InboxItem.
 * Use `create(InboxItemSchema)` to create a new message.
 */
export const InboxItemSchema: GenMessage<InboxItem> = /*@__PURE__*/
  messageDesc(file_gd_platform, 60);

/**
 * Something that happened to you, once: a mention, a failed check or a refused land of an
 * agent you answer for.
 *
 * @generated from message gd.v1.InboxNote
 */
export type InboxNote = Message<"gd.v1.InboxNote"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * mention, check or refused.
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: gd.v1.RepositoryRef repository = 3;
   */
  repository?: RepositoryRef | undefined;

  /**
   * The issue or change request (0 for a refused land, which has none).
   *
   * @generated from field: uint64 number = 4;
   */
  number: bigint;

  /**
   * Its title; for a refused land, why.
   *
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * Who did it (who mentioned you; the agent whose check failed or land was refused).
   *
   * @generated from field: string actor = 6;
   */
  actor: string;

  /**
   * For a mention: the words around it.
   *
   * @generated from field: string excerpt = 7;
   */
  excerpt: string;

  /**
   * For a mention in a comment: the comment's id (empty: in the description).
   *
   * @generated from field: string anchor = 8;
   */
  anchor: string;

  /**
   * @generated from field: int64 at_ms = 9;
   */
  atMs: bigint;

  /**
   * @generated from field: bool change_request = 10;
   */
  changeRequest: boolean;
};

/**
 * Describes the message gd.v1.InboxNote.
 * Use `create(InboxNoteSchema)` to create a new message.
 */
export const InboxNoteSchema: GenMessage<InboxNote> = /*@__PURE__*/
  messageDesc(file_gd_platform, 61);

/**
 * @generated from message gd.v1.InboxResponse
 */
export type InboxResponse = Message<"gd.v1.InboxResponse"> & {
  /**
   * @generated from field: repeated gd.v1.InboxItem items = 1;
   */
  items: InboxItem[];
};

/**
 * Describes the message gd.v1.InboxResponse.
 * Use `create(InboxResponseSchema)` to create a new message.
 */
export const InboxResponseSchema: GenMessage<InboxResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 62);

/**
 * Marks inbox items read, or done: a done item leaves the inbox until something new happens on
 * it. Items name a change request or issue by repository and number.
 *
 * @generated from message gd.v1.MarkInboxRequest
 */
export type MarkInboxRequest = Message<"gd.v1.MarkInboxRequest"> & {
  /**
   * @generated from field: repeated gd.v1.MarkInboxRequest.Item items = 1;
   */
  items: MarkInboxRequest_Item[];

  /**
   * @generated from field: bool done = 2;
   */
  done: boolean;

  /**
   * Notes (InboxNote.id) seen or done.
   *
   * @generated from field: repeated string notes = 3;
   */
  notes: string[];
};

/**
 * Describes the message gd.v1.MarkInboxRequest.
 * Use `create(MarkInboxRequestSchema)` to create a new message.
 */
export const MarkInboxRequestSchema: GenMessage<MarkInboxRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 63);

/**
 * @generated from message gd.v1.MarkInboxRequest.Item
 */
export type MarkInboxRequest_Item = Message<"gd.v1.MarkInboxRequest.Item"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: uint64 number = 2;
   */
  number: bigint;
};

/**
 * Describes the message gd.v1.MarkInboxRequest.Item.
 * Use `create(MarkInboxRequest_ItemSchema)` to create a new message.
 */
export const MarkInboxRequest_ItemSchema: GenMessage<MarkInboxRequest_Item> = /*@__PURE__*/
  messageDesc(file_gd_platform, 63, 0);

/**
 * @generated from message gd.v1.ListEventsRequest
 */
export type ListEventsRequest = Message<"gd.v1.ListEventsRequest"> & {
  /**
   * Empty: every repository the caller can read.
   *
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: string actor = 2;
   */
  actor: string;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;

  /**
   * Across repositories: only those the caller is involved in (as for ListRepositories).
   *
   * @generated from field: bool involved = 5;
   */
  involved: boolean;
};

/**
 * Describes the message gd.v1.ListEventsRequest.
 * Use `create(ListEventsRequestSchema)` to create a new message.
 */
export const ListEventsRequestSchema: GenMessage<ListEventsRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 64);

/**
 * @generated from message gd.v1.ListEventsResponse
 */
export type ListEventsResponse = Message<"gd.v1.ListEventsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Event events = 1;
   */
  events: Event[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message gd.v1.ListEventsResponse.
 * Use `create(ListEventsResponseSchema)` to create a new message.
 */
export const ListEventsResponseSchema: GenMessage<ListEventsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 65);

/**
 * Issues and change requests share one numbering per repository, so `#12` names one thing.
 *
 * @generated from message gd.v1.Issue
 */
export type Issue = Message<"gd.v1.Issue"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: uint64 number = 2;
   */
  number: bigint;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string body = 4;
   */
  body: string;

  /**
   * @generated from field: string author = 5;
   */
  author: string;

  /**
   * @generated from field: gd.v1.IssueState state = 6;
   */
  state: IssueState;

  /**
   * @generated from field: repeated string labels = 7;
   */
  labels: string[];

  /**
   * People or agents working on it.
   *
   * @generated from field: repeated string assignees = 8;
   */
  assignees: string[];

  /**
   * @generated from field: int64 created_at_ms = 9;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: int64 updated_at_ms = 10;
   */
  updatedAtMs: bigint;

  /**
   * @generated from field: int64 closed_at_ms = 11;
   */
  closedAtMs: bigint;

  /**
   * @generated from field: uint32 comments = 12;
   */
  comments: number;

  /**
   * Change requests that say they fix it.
   *
   * @generated from field: repeated uint64 fixed_by = 13;
   */
  fixedBy: bigint[];

  /**
   * Issues and change requests that mention it (#12); filled in when one issue is read.
   *
   * @generated from field: repeated uint64 referenced_by = 14;
   */
  referencedBy: bigint[];

  /**
   * The milestone it's planned for (its number); 0: none.
   *
   * @generated from field: uint64 milestone = 15;
   */
  milestone: bigint;
};

/**
 * Describes the message gd.v1.Issue.
 * Use `create(IssueSchema)` to create a new message.
 */
export const IssueSchema: GenMessage<Issue> = /*@__PURE__*/
  messageDesc(file_gd_platform, 66);

/**
 * Counts for narrowing a list: how many in each view, and the labels, assignees, authors or
 * reviewers in use (most used first).
 *
 * @generated from message gd.v1.FacetCount
 */
export type FacetCount = Message<"gd.v1.FacetCount"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: uint64 count = 2;
   */
  count: bigint;
};

/**
 * Describes the message gd.v1.FacetCount.
 * Use `create(FacetCountSchema)` to create a new message.
 */
export const FacetCountSchema: GenMessage<FacetCount> = /*@__PURE__*/
  messageDesc(file_gd_platform, 67);

/**
 * @generated from message gd.v1.Facets
 */
export type Facets = Message<"gd.v1.Facets"> & {
  /**
   * @generated from field: repeated gd.v1.FacetCount views = 1;
   */
  views: FacetCount[];

  /**
   * Issues: labels and assignees of open issues. Change requests: authors and reviewers of
   * open ones.
   *
   * @generated from field: repeated gd.v1.FacetCount first = 2;
   */
  first: FacetCount[];

  /**
   * @generated from field: repeated gd.v1.FacetCount second = 3;
   */
  second: FacetCount[];
};

/**
 * Describes the message gd.v1.Facets.
 * Use `create(FacetsSchema)` to create a new message.
 */
export const FacetsSchema: GenMessage<Facets> = /*@__PURE__*/
  messageDesc(file_gd_platform, 68);

/**
 * @generated from message gd.v1.Invitation
 */
export type Invitation = Message<"gd.v1.Invitation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org = 2;
   */
  org: string;

  /**
   * Where the link was sent; whoever has the link may accept it.
   *
   * @generated from field: string email = 3;
   */
  email: string;

  /**
   * @generated from field: gd.v1.Role role = 4;
   */
  role: Role;

  /**
   * @generated from field: string invited_by = 5;
   */
  invitedBy: string;

  /**
   * @generated from field: int64 created_at_ms = 6;
   */
  createdAtMs: bigint;

  /**
   * @generated from field: int64 expires_at_ms = 7;
   */
  expiresAtMs: bigint;
};

/**
 * Describes the message gd.v1.Invitation.
 * Use `create(InvitationSchema)` to create a new message.
 */
export const InvitationSchema: GenMessage<Invitation> = /*@__PURE__*/
  messageDesc(file_gd_platform, 69);

/**
 * @generated from message gd.v1.CreateInvitationRequest
 */
export type CreateInvitationRequest = Message<"gd.v1.CreateInvitationRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * ROLE_UNSPECIFIED: read.
   *
   * @generated from field: gd.v1.Role role = 3;
   */
  role: Role;
};

/**
 * Describes the message gd.v1.CreateInvitationRequest.
 * Use `create(CreateInvitationRequestSchema)` to create a new message.
 */
export const CreateInvitationRequestSchema: GenMessage<CreateInvitationRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 70);

/**
 * @generated from message gd.v1.CreateInvitationResponse
 */
export type CreateInvitationResponse = Message<"gd.v1.CreateInvitationResponse"> & {
  /**
   * @generated from field: gd.v1.Invitation invitation = 1;
   */
  invitation?: Invitation | undefined;

  /**
   * The link, shown once, to share by hand when the server sends no mail.
   *
   * @generated from field: string link = 2;
   */
  link: string;

  /**
   * @generated from field: bool emailed = 3;
   */
  emailed: boolean;
};

/**
 * Describes the message gd.v1.CreateInvitationResponse.
 * Use `create(CreateInvitationResponseSchema)` to create a new message.
 */
export const CreateInvitationResponseSchema: GenMessage<CreateInvitationResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 71);

/**
 * @generated from message gd.v1.ListInvitationsResponse
 */
export type ListInvitationsResponse = Message<"gd.v1.ListInvitationsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.Invitation invitations = 1;
   */
  invitations: Invitation[];
};

/**
 * Describes the message gd.v1.ListInvitationsResponse.
 * Use `create(ListInvitationsResponseSchema)` to create a new message.
 */
export const ListInvitationsResponseSchema: GenMessage<ListInvitationsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 72);

/**
 * @generated from message gd.v1.InvitationRef
 */
export type InvitationRef = Message<"gd.v1.InvitationRef"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message gd.v1.InvitationRef.
 * Use `create(InvitationRefSchema)` to create a new message.
 */
export const InvitationRefSchema: GenMessage<InvitationRef> = /*@__PURE__*/
  messageDesc(file_gd_platform, 73);

/**
 * What an organisation may use. An unset limit is unlimited.
 *
 * @generated from message gd.v1.OrgLimits
 */
export type OrgLimits = Message<"gd.v1.OrgLimits"> & {
  /**
   * @generated from field: optional uint64 seats = 1;
   */
  seats?: bigint | undefined;

  /**
   * Agents that land at least one change in a calendar month (UTC).
   *
   * @generated from field: optional uint64 active_agents = 2;
   */
  activeAgents?: bigint | undefined;

  /**
   * @generated from field: optional uint64 storage_bytes = 3;
   */
  storageBytes?: bigint | undefined;

  /**
   * @generated from field: optional uint64 private_repos = 4;
   */
  privateRepos?: bigint | undefined;

  /**
   * Set only by SetSuspended; SetLimits leaves it as it is.
   *
   * @generated from field: bool suspended = 5;
   */
  suspended: boolean;

  /**
   * @generated from field: string plan_label = 6;
   */
  planLabel: string;

  /**
   * Calls a minute each person or agent may make to the organisation's repositories (anonymous
   * readers of public repositories share four times this); beyond it, RESOURCE_EXHAUSTED.
   *
   * @generated from field: optional uint64 calls_per_minute = 7;
   */
  callsPerMinute?: bigint | undefined;

  /**
   * Minutes a calendar month (UTC) of jobs on the server's hosted runners; your own runners
   * are never counted.
   *
   * @generated from field: optional uint64 hosted_minutes = 8;
   */
  hostedMinutes?: bigint | undefined;

  /**
   * Jobs at once on hosted runners.
   *
   * @generated from field: optional uint64 hosted_jobs = 9;
   */
  hostedJobs?: bigint | undefined;
};

/**
 * Describes the message gd.v1.OrgLimits.
 * Use `create(OrgLimitsSchema)` to create a new message.
 */
export const OrgLimitsSchema: GenMessage<OrgLimits> = /*@__PURE__*/
  messageDesc(file_gd_platform, 74);

/**
 * @generated from message gd.v1.GetUsageRequest
 */
export type GetUsageRequest = Message<"gd.v1.GetUsageRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * `YYYY-MM`; empty: this month (UTC).
   *
   * @generated from field: string month = 2;
   */
  month: string;
};

/**
 * Describes the message gd.v1.GetUsageRequest.
 * Use `create(GetUsageRequestSchema)` to create a new message.
 */
export const GetUsageRequestSchema: GenMessage<GetUsageRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 75);

/**
 * @generated from message gd.v1.ActiveAgent
 */
export type ActiveAgent = Message<"gd.v1.ActiveAgent"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * When it first landed a change in the month.
   *
   * @generated from field: int64 first_at_ms = 2;
   */
  firstAtMs: bigint;
};

/**
 * Describes the message gd.v1.ActiveAgent.
 * Use `create(ActiveAgentSchema)` to create a new message.
 */
export const ActiveAgentSchema: GenMessage<ActiveAgent> = /*@__PURE__*/
  messageDesc(file_gd_platform, 76);

/**
 * @generated from message gd.v1.Usage
 */
export type Usage = Message<"gd.v1.Usage"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: string month = 2;
   */
  month: string;

  /**
   * @generated from field: repeated gd.v1.ActiveAgent active_agents = 3;
   */
  activeAgents: ActiveAgent[];

  /**
   * People (not agents) who are members.
   *
   * @generated from field: uint32 seats = 4;
   */
  seats: number;

  /**
   * At the last measurement (hourly), and the month's highest.
   *
   * @generated from field: uint64 storage_bytes = 5;
   */
  storageBytes: bigint;

  /**
   * @generated from field: uint64 peak_storage_bytes = 6;
   */
  peakStorageBytes: bigint;

  /**
   * @generated from field: int64 storage_measured_at_ms = 7;
   */
  storageMeasuredAtMs: bigint;

  /**
   * @generated from field: uint32 private_repos = 8;
   */
  privateRepos: number;

  /**
   * The limits that apply now: the organisation's own, or the server's defaults.
   *
   * @generated from field: gd.v1.OrgLimits limits = 9;
   */
  limits?: OrgLimits | undefined;

  /**
   * Limits are enforced (`--multi-tenant`).
   *
   * @generated from field: bool enforced = 10;
   */
  enforced: boolean;

  /**
   * Minutes of hosted runners used this month (each job rounded up to a minute).
   *
   * @generated from field: uint64 hosted_minutes_used = 11;
   */
  hostedMinutesUsed: bigint;

  /**
   * Hosted runners online on this server now (0: it offers none).
   *
   * @generated from field: uint32 hosted_runners_online = 12;
   */
  hostedRunnersOnline: number;
};

/**
 * Describes the message gd.v1.Usage.
 * Use `create(UsageSchema)` to create a new message.
 */
export const UsageSchema: GenMessage<Usage> = /*@__PURE__*/
  messageDesc(file_gd_platform, 77);

/**
 * @generated from message gd.v1.SetLimitsRequest
 */
export type SetLimitsRequest = Message<"gd.v1.SetLimitsRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: gd.v1.OrgLimits limits = 2;
   */
  limits?: OrgLimits | undefined;
};

/**
 * Describes the message gd.v1.SetLimitsRequest.
 * Use `create(SetLimitsRequestSchema)` to create a new message.
 */
export const SetLimitsRequestSchema: GenMessage<SetLimitsRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 78);

/**
 * @generated from message gd.v1.SetSuspendedRequest
 */
export type SetSuspendedRequest = Message<"gd.v1.SetSuspendedRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: bool suspended = 2;
   */
  suspended: boolean;
};

/**
 * Describes the message gd.v1.SetSuspendedRequest.
 * Use `create(SetSuspendedRequestSchema)` to create a new message.
 */
export const SetSuspendedRequestSchema: GenMessage<SetSuspendedRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 79);

/**
 * @generated from message gd.v1.Capabilities
 */
export type Capabilities = Message<"gd.v1.Capabilities"> & {
  /**
   * Where organisation administrators change their plan; empty: nowhere.
   *
   * @generated from field: string billing_url = 1;
   */
  billingUrl: string;

  /**
   * Organisations have limits (`--multi-tenant`).
   *
   * @generated from field: bool limits = 2;
   */
  limits: boolean;

  /**
   * Where people reach support (mailto: or https:); empty: not given.
   *
   * @generated from field: string support_url = 3;
   */
  supportUrl: string;

  /**
   * Stock git clones and pushes over HTTPS (`git clone https://HOST/OWNER/NAME.git`).
   *
   * @generated from field: bool git_http = 4;
   */
  gitHttp: boolean;
};

/**
 * Describes the message gd.v1.Capabilities.
 * Use `create(CapabilitiesSchema)` to create a new message.
 */
export const CapabilitiesSchema: GenMessage<Capabilities> = /*@__PURE__*/
  messageDesc(file_gd_platform, 80);

/**
 * @generated from message gd.v1.License
 */
export type License = Message<"gd.v1.License"> & {
  /**
   * A licence was given (`--license`).
   *
   * @generated from field: bool present = 1;
   */
  present: boolean;

  /**
   * valid, grace, expired or invalid.
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * Why it is invalid.
   *
   * @generated from field: string error = 3;
   */
  error: string;

  /**
   * @generated from field: string licensee = 4;
   */
  licensee: string;

  /**
   * @generated from field: string product = 5;
   */
  product: string;

  /**
   * @generated from field: uint32 seats = 6;
   */
  seats: number;

  /**
   * @generated from field: uint32 agents = 7;
   */
  agents: number;

  /**
   * @generated from field: int64 issued_at = 8;
   */
  issuedAt: bigint;

  /**
   * @generated from field: int64 expires_at = 9;
   */
  expiresAt: bigint;

  /**
   * @generated from field: uint32 grace_days = 10;
   */
  graceDays: number;
};

/**
 * Describes the message gd.v1.License.
 * Use `create(LicenseSchema)` to create a new message.
 */
export const LicenseSchema: GenMessage<License> = /*@__PURE__*/
  messageDesc(file_gd_platform, 81);

/**
 * @generated from message gd.v1.ConflictFile
 */
export type ConflictFile = Message<"gd.v1.ConflictFile"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * What clashes: "both changed", "both added", "deleted on the target", "deleted on the branch",
   * "file and folder", "binary", "too large".
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * The file where the two sides parted, on the target now, and on the branch; empty when
   * missing, binary or too large.
   *
   * @generated from field: string base = 3;
   */
  base: string;

  /**
   * @generated from field: string target = 4;
   */
  target: string;

  /**
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * True when the edits combine line by line: `merged` is then the result.
   *
   * @generated from field: bool clean = 6;
   */
  clean: boolean;

  /**
   * The merge, with `<<<<<<< target` / `=======` / `>>>>>>> branch` around each clash.
   *
   * @generated from field: string merged = 7;
   */
  merged: string;

  /**
   * @generated from field: uint32 clashes = 8;
   */
  clashes: number;
};

/**
 * Describes the message gd.v1.ConflictFile.
 * Use `create(ConflictFileSchema)` to create a new message.
 */
export const ConflictFileSchema: GenMessage<ConflictFile> = /*@__PURE__*/
  messageDesc(file_gd_platform, 82);

/**
 * @generated from message gd.v1.ConflictReport
 */
export type ConflictReport = Message<"gd.v1.ConflictReport"> & {
  /**
   * @generated from field: string target = 1;
   */
  target: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * The target's tip the report was made against, and where the two parted.
   *
   * @generated from field: bytes target_tip = 3;
   */
  targetTip: Uint8Array;

  /**
   * @generated from field: bytes base = 4;
   */
  base: Uint8Array;

  /**
   * @generated from field: repeated gd.v1.ConflictFile files = 5;
   */
  files: ConflictFile[];
};

/**
 * Describes the message gd.v1.ConflictReport.
 * Use `create(ConflictReportSchema)` to create a new message.
 */
export const ConflictReportSchema: GenMessage<ConflictReport> = /*@__PURE__*/
  messageDesc(file_gd_platform, 83);

/**
 * @generated from message gd.v1.FileResolution
 */
export type FileResolution = Message<"gd.v1.FileResolution"> & {
  /**
   * @generated from field: string path = 1;
   */
  path: string;

  /**
   * The file's whole content as it should be; ignored when `delete`.
   *
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: bool delete = 3;
   */
  delete: boolean;
};

/**
 * Describes the message gd.v1.FileResolution.
 * Use `create(FileResolutionSchema)` to create a new message.
 */
export const FileResolutionSchema: GenMessage<FileResolution> = /*@__PURE__*/
  messageDesc(file_gd_platform, 84);

/**
 * @generated from message gd.v1.ResolveConflictsRequest
 */
export type ResolveConflictsRequest = Message<"gd.v1.ResolveConflictsRequest"> & {
  /**
   * @generated from field: gd.v1.ChangeRequestRef ref = 1;
   */
  ref?: ChangeRequestRef | undefined;

  /**
   * @generated from field: repeated gd.v1.FileResolution files = 2;
   */
  files: FileResolution[];
};

/**
 * Describes the message gd.v1.ResolveConflictsRequest.
 * Use `create(ResolveConflictsRequestSchema)` to create a new message.
 */
export const ResolveConflictsRequestSchema: GenMessage<ResolveConflictsRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 85);

/**
 * @generated from message gd.v1.RevertAgentRequest
 */
export type RevertAgentRequest = Message<"gd.v1.RevertAgentRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * The agent, e.g. agent/acme-claude.
   *
   * @generated from field: string agent = 2;
   */
  agent: string;

  /**
   * Undo what it landed at or after this time.
   *
   * @generated from field: int64 since_ms = 3;
   */
  sinceMs: bigint;

  /**
   * The branch; empty: the default branch.
   *
   * @generated from field: string target = 4;
   */
  target: string;

  /**
   * @generated from field: bool dry_run = 5;
   */
  dryRun: boolean;
};

/**
 * Describes the message gd.v1.RevertAgentRequest.
 * Use `create(RevertAgentRequestSchema)` to create a new message.
 */
export const RevertAgentRequestSchema: GenMessage<RevertAgentRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 86);

/**
 * @generated from message gd.v1.RevertedChange
 */
export type RevertedChange = Message<"gd.v1.RevertedChange"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: int64 at_ms = 3;
   */
  atMs: bigint;

  /**
   * @generated from field: uint32 files = 4;
   */
  files: number;
};

/**
 * Describes the message gd.v1.RevertedChange.
 * Use `create(RevertedChangeSchema)` to create a new message.
 */
export const RevertedChangeSchema: GenMessage<RevertedChange> = /*@__PURE__*/
  messageDesc(file_gd_platform, 87);

/**
 * @generated from message gd.v1.RevertPlan
 */
export type RevertPlan = Message<"gd.v1.RevertPlan"> & {
  /**
   * The agent's changes being undone, newest first.
   *
   * @generated from field: repeated gd.v1.RevertedChange changes = 1;
   */
  changes: RevertedChange[];

  /**
   * Files the undo changes.
   *
   * @generated from field: repeated string files = 2;
   */
  files: string[];

  /**
   * Files someone else changed afterwards in the same places: left as they are, for a person
   * to look at.
   *
   * @generated from field: repeated string clashes = 3;
   */
  clashes: string[];

  /**
   * The change request it opened (not with dry_run, nor when there's nothing to undo).
   *
   * @generated from field: gd.v1.ChangeRequest change_request = 4;
   */
  changeRequest?: ChangeRequest | undefined;

  /**
   * True when the history walked stopped at its limit before reaching `since_ms`.
   *
   * @generated from field: bool stopped = 5;
   */
  stopped: boolean;
};

/**
 * Describes the message gd.v1.RevertPlan.
 * Use `create(RevertPlanSchema)` to create a new message.
 */
export const RevertPlanSchema: GenMessage<RevertPlan> = /*@__PURE__*/
  messageDesc(file_gd_platform, 88);

/**
 * What a person gets emailed about: reviews asked of them, assignments, mentions, and failed
 * checks on their (or their agents') changes, gathered into one mail every few minutes.
 *
 * @generated from message gd.v1.NotificationSettings
 */
export type NotificationSettings = Message<"gd.v1.NotificationSettings"> & {
  /**
   * Any email at all.
   *
   * @generated from field: bool email = 1;
   */
  email: boolean;

  /**
   * Kinds turned off: review, assigned, mention, check.
   *
   * @generated from field: repeated string off = 2;
   */
  off: string[];

  /**
   * Where it goes (read-only): the address they signed in with.
   *
   * @generated from field: string address = 3;
   */
  address: string;
};

/**
 * Describes the message gd.v1.NotificationSettings.
 * Use `create(NotificationSettingsSchema)` to create a new message.
 */
export const NotificationSettingsSchema: GenMessage<NotificationSettings> = /*@__PURE__*/
  messageDesc(file_gd_platform, 89);

/**
 * @generated from message gd.v1.AgentStatsRequest
 */
export type AgentStatsRequest = Message<"gd.v1.AgentStatsRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * Days back (default 14, at most 90).
   *
   * @generated from field: uint32 days = 2;
   */
  days: number;
};

/**
 * Describes the message gd.v1.AgentStatsRequest.
 * Use `create(AgentStatsRequestSchema)` to create a new message.
 */
export const AgentStatsRequestSchema: GenMessage<AgentStatsRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 90);

/**
 * @generated from message gd.v1.AgentStat
 */
export type AgentStat = Message<"gd.v1.AgentStat"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string owner = 2;
   */
  owner: string;

  /**
   * @generated from field: bool paused = 3;
   */
  paused: boolean;

  /**
   * Landed straight on branches, per day, oldest first, and in all.
   *
   * @generated from field: repeated uint32 daily = 4;
   */
  daily: number[];

  /**
   * @generated from field: uint32 lands = 5;
   */
  lands: number;

  /**
   * @generated from field: uint32 change_requests_opened = 6;
   */
  changeRequestsOpened: number;

  /**
   * @generated from field: uint32 change_requests_landed = 7;
   */
  changeRequestsLanded: number;

  /**
   * @generated from field: uint32 change_requests_closed = 8;
   */
  changeRequestsClosed: number;

  /**
   * Checks that failed on its change requests.
   *
   * @generated from field: uint32 checks_failed = 9;
   */
  checksFailed: number;

  /**
   * Lands it tried that were refused, and the latest reason.
   *
   * @generated from field: uint32 refused = 10;
   */
  refused: number;

  /**
   * @generated from field: string last_refusal = 11;
   */
  lastRefusal: string;

  /**
   * @generated from field: int64 last_active_ms = 12;
   */
  lastActiveMs: bigint;

  /**
   * What it can reach: its role here (empty: its owner's), the repositories its tokens are kept
   * to (empty: any it has a role in), and the paths it may change (empty: any).
   *
   * @generated from field: string role = 13;
   */
  role: string;

  /**
   * @generated from field: repeated string repositories = 14;
   */
  repositories: string[];

  /**
   * @generated from field: repeated string allowed_paths = 15;
   */
  allowedPaths: string[];

  /**
   * Its daily budgets and what it used today (UTC).
   *
   * @generated from field: optional uint32 lands_per_day = 16;
   */
  landsPerDay?: number | undefined;

  /**
   * @generated from field: optional uint32 runs_per_day = 17;
   */
  runsPerDay?: number | undefined;

  /**
   * @generated from field: uint32 lands_today = 18;
   */
  landsToday: number;

  /**
   * @generated from field: uint32 runs_today = 19;
   */
  runsToday: number;
};

/**
 * Describes the message gd.v1.AgentStat.
 * Use `create(AgentStatSchema)` to create a new message.
 */
export const AgentStatSchema: GenMessage<AgentStat> = /*@__PURE__*/
  messageDesc(file_gd_platform, 91);

/**
 * @generated from message gd.v1.AgentStatsResponse
 */
export type AgentStatsResponse = Message<"gd.v1.AgentStatsResponse"> & {
  /**
   * @generated from field: repeated gd.v1.AgentStat agents = 1;
   */
  agents: AgentStat[];

  /**
   * @generated from field: int64 from_ms = 2;
   */
  fromMs: bigint;

  /**
   * @generated from field: uint32 days = 3;
   */
  days: number;

  /**
   * Every agent is stopped from writing here, by this person.
   *
   * @generated from field: bool agents_paused = 4;
   */
  agentsPaused: boolean;

  /**
   * @generated from field: string agents_paused_by = 5;
   */
  agentsPausedBy: string;
};

/**
 * Describes the message gd.v1.AgentStatsResponse.
 * Use `create(AgentStatsResponseSchema)` to create a new message.
 */
export const AgentStatsResponseSchema: GenMessage<AgentStatsResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 92);

/**
 * @generated from message gd.v1.AgentActivityRequest
 */
export type AgentActivityRequest = Message<"gd.v1.AgentActivityRequest"> & {
  /**
   * @generated from field: string org = 1;
   */
  org: string;

  /**
   * @generated from field: string agent = 2;
   */
  agent: string;

  /**
   * Days back (default 7, at most 7: calls are kept a week).
   *
   * @generated from field: uint32 days = 3;
   */
  days: number;
};

/**
 * Describes the message gd.v1.AgentActivityRequest.
 * Use `create(AgentActivityRequestSchema)` to create a new message.
 */
export const AgentActivityRequestSchema: GenMessage<AgentActivityRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 93);

/**
 * One thing an agent did, or several of the same in a row ("read 14 files").
 *
 * @generated from message gd.v1.AgentStep
 */
export type AgentStep = Message<"gd.v1.AgentStep"> & {
  /**
   * @generated from field: int64 at_ms = 1;
   */
  atMs: bigint;

  /**
   * @generated from field: int64 until_ms = 2;
   */
  untilMs: bigint;

  /**
   * read, search, write, land, lock, change request, check, other.
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string what = 4;
   */
  what: string;

  /**
   * OWNER/NAME.
   *
   * @generated from field: string repo = 5;
   */
  repo: string;

  /**
   * @generated from field: bool ok = 6;
   */
  ok: boolean;

  /**
   * Why it failed, or the change's title.
   *
   * @generated from field: string detail = 7;
   */
  detail: string;

  /**
   * @generated from field: uint32 count = 8;
   */
  count: number;

  /**
   * The change request or issue it's about, when there is one.
   *
   * @generated from field: uint64 number = 9;
   */
  number: bigint;
};

/**
 * Describes the message gd.v1.AgentStep.
 * Use `create(AgentStepSchema)` to create a new message.
 */
export const AgentStepSchema: GenMessage<AgentStep> = /*@__PURE__*/
  messageDesc(file_gd_platform, 94);

/**
 * Steps with no gap of 20 minutes or more between them.
 *
 * @generated from message gd.v1.AgentSession
 */
export type AgentSession = Message<"gd.v1.AgentSession"> & {
  /**
   * @generated from field: int64 start_ms = 1;
   */
  startMs: bigint;

  /**
   * @generated from field: int64 end_ms = 2;
   */
  endMs: bigint;

  /**
   * @generated from field: repeated string repos = 3;
   */
  repos: string[];

  /**
   * @generated from field: repeated gd.v1.AgentStep steps = 4;
   */
  steps: AgentStep[];

  /**
   * @generated from field: uint32 failed = 5;
   */
  failed: number;
};

/**
 * Describes the message gd.v1.AgentSession.
 * Use `create(AgentSessionSchema)` to create a new message.
 */
export const AgentSessionSchema: GenMessage<AgentSession> = /*@__PURE__*/
  messageDesc(file_gd_platform, 95);

/**
 * @generated from message gd.v1.AgentActivityResponse
 */
export type AgentActivityResponse = Message<"gd.v1.AgentActivityResponse"> & {
  /**
   * Newest first.
   *
   * @generated from field: repeated gd.v1.AgentSession sessions = 1;
   */
  sessions: AgentSession[];

  /**
   * @generated from field: string owner = 2;
   */
  owner: string;

  /**
   * @generated from field: bool paused = 3;
   */
  paused: boolean;
};

/**
 * Describes the message gd.v1.AgentActivityResponse.
 * Use `create(AgentActivityResponseSchema)` to create a new message.
 */
export const AgentActivityResponseSchema: GenMessage<AgentActivityResponse> = /*@__PURE__*/
  messageDesc(file_gd_platform, 96);

/**
 * A repository's git host sync. `url` empty: none is set up.
 *
 * @generated from message gd.v1.GitSync
 */
export type GitSync = Message<"gd.v1.GitSync"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * This repository's branch, and the git host's branch it updates.
   *
   * @generated from field: string from_ref = 3;
   */
  fromRef: string;

  /**
   * @generated from field: string to_ref = 4;
   */
  toRef: string;

  /**
   * @generated from field: string set_by = 5;
   */
  setBy: string;

  /**
   * @generated from field: int64 set_at_ms = 6;
   */
  setAtMs: bigint;

  /**
   * The git commit last pushed, and when.
   *
   * @generated from field: string pushed_commit = 7;
   */
  pushedCommit: string;

  /**
   * @generated from field: int64 pushed_at_ms = 8;
   */
  pushedAtMs: bigint;

  /**
   * Why the last try failed, in words for people; empty when it didn't.
   *
   * @generated from field: string error = 9;
   */
  error: string;

  /**
   * @generated from field: int64 tried_at_ms = 10;
   */
  triedAtMs: bigint;
};

/**
 * Describes the message gd.v1.GitSync.
 * Use `create(GitSyncSchema)` to create a new message.
 */
export const GitSyncSchema: GenMessage<GitSync> = /*@__PURE__*/
  messageDesc(file_gd_platform, 97);

/**
 * @generated from message gd.v1.SetGitSyncRequest
 */
export type SetGitSyncRequest = Message<"gd.v1.SetGitSyncRequest"> & {
  /**
   * @generated from field: gd.v1.RepositoryRef repository = 1;
   */
  repository?: RepositoryRef | undefined;

  /**
   * An https git URL, e.g. https://github.com/acme/fleet.git.
   *
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string from_ref = 3;
   */
  fromRef: string;

  /**
   * @generated from field: string to_ref = 4;
   */
  toRef: string;

  /**
   * A token with write access to the host repository's contents. Kept sealed; never returned.
   *
   * @generated from field: string token = 5;
   */
  token: string;
};

/**
 * Describes the message gd.v1.SetGitSyncRequest.
 * Use `create(SetGitSyncRequestSchema)` to create a new message.
 */
export const SetGitSyncRequestSchema: GenMessage<SetGitSyncRequest> = /*@__PURE__*/
  messageDesc(file_gd_platform, 98);

/**
 * @generated from enum gd.v1.AccountKind
 */
export enum AccountKind {
  /**
   * @generated from enum value: ACCOUNT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACCOUNT_KIND_PERSON = 1;
   */
  PERSON = 1,

  /**
   * An automated author. Agents are owned by a person or a team, who answer for them.
   *
   * @generated from enum value: ACCOUNT_KIND_AGENT = 2;
   */
  AGENT = 2,

  /**
   * @generated from enum value: ACCOUNT_KIND_ORGANIZATION = 3;
   */
  ORGANIZATION = 3,
}

/**
 * Describes the enum gd.v1.AccountKind.
 */
export const AccountKindSchema: GenEnum<AccountKind> = /*@__PURE__*/
  enumDesc(file_gd_platform, 0);

/**
 * @generated from enum gd.v1.Visibility
 */
export enum Visibility {
  /**
   * @generated from enum value: VISIBILITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VISIBILITY_PRIVATE = 1;
   */
  PRIVATE = 1,

  /**
   * @generated from enum value: VISIBILITY_INTERNAL = 2;
   */
  INTERNAL = 2,

  /**
   * @generated from enum value: VISIBILITY_PUBLIC = 3;
   */
  PUBLIC = 3,
}

/**
 * Describes the enum gd.v1.Visibility.
 */
export const VisibilitySchema: GenEnum<Visibility> = /*@__PURE__*/
  enumDesc(file_gd_platform, 1);

/**
 * @generated from enum gd.v1.Role
 */
export enum Role {
  /**
   * @generated from enum value: ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ROLE_READ = 1;
   */
  READ = 1,

  /**
   * May open change requests and comment; may not land on protected branches.
   *
   * @generated from enum value: ROLE_TRIAGE = 2;
   */
  TRIAGE = 2,

  /**
   * @generated from enum value: ROLE_WRITE = 3;
   */
  WRITE = 3,

  /**
   * @generated from enum value: ROLE_MAINTAIN = 4;
   */
  MAINTAIN = 4,

  /**
   * @generated from enum value: ROLE_ADMIN = 5;
   */
  ADMIN = 5,
}

/**
 * Describes the enum gd.v1.Role.
 */
export const RoleSchema: GenEnum<Role> = /*@__PURE__*/
  enumDesc(file_gd_platform, 2);

/**
 * How much of a repository's news reaches a person.
 *
 * @generated from enum gd.v1.Watch
 */
export enum Watch {
  /**
   * What involves you: reviews asked of you, your issues, mentions, your failed checks.
   *
   * @generated from enum value: WATCH_PARTICIPATING = 0;
   */
  PARTICIPATING = 0,

  /**
   * That, and every new issue, change request and release.
   *
   * @generated from enum value: WATCH_ALL = 1;
   */
  ALL = 1,

  /**
   * Nothing from this repository, mentions included.
   *
   * @generated from enum value: WATCH_IGNORE = 2;
   */
  IGNORE = 2,
}

/**
 * Describes the enum gd.v1.Watch.
 */
export const WatchSchema: GenEnum<Watch> = /*@__PURE__*/
  enumDesc(file_gd_platform, 3);

/**
 * @generated from enum gd.v1.ChangeRequestState
 */
export enum ChangeRequestState {
  /**
   * @generated from enum value: CHANGE_REQUEST_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHANGE_REQUEST_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: CHANGE_REQUEST_STATE_DRAFT = 2;
   */
  DRAFT = 2,

  /**
   * @generated from enum value: CHANGE_REQUEST_STATE_LANDED = 3;
   */
  LANDED = 3,

  /**
   * @generated from enum value: CHANGE_REQUEST_STATE_CLOSED = 4;
   */
  CLOSED = 4,
}

/**
 * Describes the enum gd.v1.ChangeRequestState.
 */
export const ChangeRequestStateSchema: GenEnum<ChangeRequestState> = /*@__PURE__*/
  enumDesc(file_gd_platform, 4);

/**
 * @generated from enum gd.v1.Verdict
 */
export enum Verdict {
  /**
   * @generated from enum value: VERDICT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VERDICT_COMMENTED = 1;
   */
  COMMENTED = 1,

  /**
   * @generated from enum value: VERDICT_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: VERDICT_CHANGES_REQUESTED = 3;
   */
  CHANGES_REQUESTED = 3,
}

/**
 * Describes the enum gd.v1.Verdict.
 */
export const VerdictSchema: GenEnum<Verdict> = /*@__PURE__*/
  enumDesc(file_gd_platform, 5);

/**
 * @generated from enum gd.v1.CheckState
 */
export enum CheckState {
  /**
   * @generated from enum value: CHECK_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHECK_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: CHECK_STATE_PASSED = 2;
   */
  PASSED = 2,

  /**
   * @generated from enum value: CHECK_STATE_FAILED = 3;
   */
  FAILED = 3,

  /**
   * @generated from enum value: CHECK_STATE_SKIPPED = 4;
   */
  SKIPPED = 4,
}

/**
 * Describes the enum gd.v1.CheckState.
 */
export const CheckStateSchema: GenEnum<CheckState> = /*@__PURE__*/
  enumDesc(file_gd_platform, 6);

/**
 * @generated from enum gd.v1.EventKind
 */
export enum EventKind {
  /**
   * @generated from enum value: EVENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EVENT_KIND_LANDED = 1;
   */
  LANDED = 1,

  /**
   * @generated from enum value: EVENT_KIND_CHANGE_REQUEST_OPENED = 2;
   */
  CHANGE_REQUEST_OPENED = 2,

  /**
   * @generated from enum value: EVENT_KIND_REVIEWED = 3;
   */
  REVIEWED = 3,

  /**
   * @generated from enum value: EVENT_KIND_COMMENTED_ON = 4;
   */
  COMMENTED_ON = 4,

  /**
   * @generated from enum value: EVENT_KIND_CHANGE_REQUEST_LANDED = 5;
   */
  CHANGE_REQUEST_LANDED = 5,

  /**
   * @generated from enum value: EVENT_KIND_CHANGE_REQUEST_CLOSED = 6;
   */
  CHANGE_REQUEST_CLOSED = 6,

  /**
   * @generated from enum value: EVENT_KIND_LOCKED = 7;
   */
  LOCKED = 7,

  /**
   * @generated from enum value: EVENT_KIND_UNLOCKED = 8;
   */
  UNLOCKED = 8,

  /**
   * @generated from enum value: EVENT_KIND_REPOSITORY_CREATED = 9;
   */
  REPOSITORY_CREATED = 9,

  /**
   * @generated from enum value: EVENT_KIND_ISSUE_OPENED = 10;
   */
  ISSUE_OPENED = 10,

  /**
   * @generated from enum value: EVENT_KIND_ISSUE_CLOSED = 11;
   */
  ISSUE_CLOSED = 11,

  /**
   * @generated from enum value: EVENT_KIND_RELEASE_PUBLISHED = 12;
   */
  RELEASE_PUBLISHED = 12,
}

/**
 * Describes the enum gd.v1.EventKind.
 */
export const EventKindSchema: GenEnum<EventKind> = /*@__PURE__*/
  enumDesc(file_gd_platform, 7);

/**
 * @generated from enum gd.v1.IssueState
 */
export enum IssueState {
  /**
   * @generated from enum value: ISSUE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ISSUE_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * Done, by hand or by a change request that said "fixes #N" landing.
   *
   * @generated from enum value: ISSUE_STATE_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: ISSUE_STATE_NOT_PLANNED = 3;
   */
  NOT_PLANNED = 3,
}

/**
 * Describes the enum gd.v1.IssueState.
 */
export const IssueStateSchema: GenEnum<IssueState> = /*@__PURE__*/
  enumDesc(file_gd_platform, 8);

/**
 * @generated from service gd.v1.Platform
 */
export const Platform: GenService<{
  /**
   * @generated from rpc gd.v1.Platform.SetAgentControls
   */
  setAgentControls: {
    methodKind: "unary";
    input: typeof SetAgentControlsRequestSchema;
    output: typeof AccountSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.SetOrgAgentsPaused
   */
  setOrgAgentsPaused: {
    methodKind: "unary";
    input: typeof SetOrgAgentsPausedRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.Viewer
   */
  viewer: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ViewerResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.GetAccount
   */
  getAccount: {
    methodKind: "unary";
    input: typeof OrgNameSchema;
    output: typeof AccountSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListOrganizations
   */
  listOrganizations: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListOrganizationsResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.GetOrganization
   */
  getOrganization: {
    methodKind: "unary";
    input: typeof OrgNameSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.CreateOrganization
   */
  createOrganization: {
    methodKind: "unary";
    input: typeof CreateOrganizationRequestSchema;
    output: typeof OrganizationSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListMembers
   */
  listMembers: {
    methodKind: "unary";
    input: typeof OrgNameSchema;
    output: typeof ListMembersResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.SetMember
   */
  setMember: {
    methodKind: "unary";
    input: typeof SetMemberRequestSchema;
    output: typeof MemberSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListTeams
   */
  listTeams: {
    methodKind: "unary";
    input: typeof OrgNameSchema;
    output: typeof ListTeamsResponseSchema;
  },
  /**
   * Creates the team, or replaces its name, description and members.
   *
   * @generated from rpc gd.v1.Platform.SetTeam
   */
  setTeam: {
    methodKind: "unary";
    input: typeof TeamSchema;
    output: typeof TeamSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.DeleteTeam
   */
  deleteTeam: {
    methodKind: "unary";
    input: typeof TeamRefSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListRepositories
   */
  listRepositories: {
    methodKind: "unary";
    input: typeof ListRepositoriesRequestSchema;
    output: typeof ListRepositoriesResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.GetRepository
   */
  getRepository: {
    methodKind: "unary";
    input: typeof RepositoryRefSchema;
    output: typeof RepositorySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.CreateRepository
   */
  createRepository: {
    methodKind: "unary";
    input: typeof CreateRepositoryRequestSchema;
    output: typeof RepositorySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.UpdateRepository
   */
  updateRepository: {
    methodKind: "unary";
    input: typeof UpdateRepositoryRequestSchema;
    output: typeof RepositorySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.RenameRepository
   */
  renameRepository: {
    methodKind: "unary";
    input: typeof RenameRepositoryRequestSchema;
    output: typeof RepositorySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.DeleteRepository
   */
  deleteRepository: {
    methodKind: "unary";
    input: typeof DeleteRepositoryRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListGrants
   */
  listGrants: {
    methodKind: "unary";
    input: typeof RepositoryRefSchema;
    output: typeof ListGrantsResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.SetGrant
   */
  setGrant: {
    methodKind: "unary";
    input: typeof SetGrantRequestSchema;
    output: typeof GrantSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListTokens
   */
  listTokens: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof ListTokensResponseSchema;
  },
  /**
   * What the caller gets emailed about.
   *
   * @generated from rpc gd.v1.Platform.GetNotificationSettings
   */
  getNotificationSettings: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof NotificationSettingsSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.SetNotificationSettings
   */
  setNotificationSettings: {
    methodKind: "unary";
    input: typeof NotificationSettingsSchema;
    output: typeof NotificationSettingsSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.CreateToken
   */
  createToken: {
    methodKind: "unary";
    input: typeof CreateTokenRequestSchema;
    output: typeof CreateTokenResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.RevokeToken
   */
  revokeToken: {
    methodKind: "unary";
    input: typeof RevokeTokenRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListWebhooks
   */
  listWebhooks: {
    methodKind: "unary";
    input: typeof RepositoryRefSchema;
    output: typeof ListWebhooksResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.CreateWebhook
   */
  createWebhook: {
    methodKind: "unary";
    input: typeof CreateWebhookRequestSchema;
    output: typeof CreateWebhookResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.DeleteWebhook
   */
  deleteWebhook: {
    methodKind: "unary";
    input: typeof WebhookRefSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.ListWebhookDeliveries
   */
  listWebhookDeliveries: {
    methodKind: "unary";
    input: typeof WebhookRefSchema;
    output: typeof ListWebhookDeliveriesResponseSchema;
  },
  /**
   * Sends a `ping` event now.
   *
   * @generated from rpc gd.v1.Platform.PingWebhook
   */
  pingWebhook: {
    methodKind: "unary";
    input: typeof WebhookRefSchema;
    output: typeof WebhookDeliverySchema;
  },
  /**
   * Keeping a git host in sync: after each land on a branch, the same branch on GitHub, GitLab
   * or Bitbucket is updated (fast-forward only). Repository administrators.
   *
   * @generated from rpc gd.v1.Platform.GetGitSync
   */
  getGitSync: {
    methodKind: "unary";
    input: typeof RepositoryRefSchema;
    output: typeof GitSyncSchema;
  },
  /**
   * Saves the sync and pushes straight away, so a wrong URL or token shows at once.
   *
   * @generated from rpc gd.v1.Platform.SetGitSync
   */
  setGitSync: {
    methodKind: "unary";
    input: typeof SetGitSyncRequestSchema;
    output: typeof GitSyncSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.DeleteGitSync
   */
  deleteGitSync: {
    methodKind: "unary";
    input: typeof RepositoryRefSchema;
    output: typeof EmptySchema;
  },
  /**
   * Lets an identity sign in as an existing account, e.g. the first administrator's email
   * address. Site administrators only.
   *
   * @generated from rpc gd.v1.Platform.LinkIdentity
   */
  linkIdentity: {
    methodKind: "unary";
    input: typeof LinkIdentityRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Invitations to an organisation: a single-use link, valid 7 days, emailed when the server
   * sends mail. Whoever opens it and signs in joins with the role. Organisation administrators.
   *
   * @generated from rpc gd.v1.Platform.CreateInvitation
   */
  createInvitation: {
    methodKind: "unary";
    input: typeof CreateInvitationRequestSchema;
    output: typeof CreateInvitationResponseSchema;
  },
  /**
   * Invitations not yet accepted, including expired ones.
   *
   * @generated from rpc gd.v1.Platform.ListInvitations
   */
  listInvitations: {
    methodKind: "unary";
    input: typeof OrgNameSchema;
    output: typeof ListInvitationsResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Platform.RevokeInvitation
   */
  revokeInvitation: {
    methodKind: "unary";
    input: typeof InvitationRefSchema;
    output: typeof EmptySchema;
  },
  /**
   * Plans and usage (ADR-035). An organisation's active agents, people, storage and limits:
   * its administrators and site administrators.
   *
   * @generated from rpc gd.v1.Platform.GetUsage
   */
  getUsage: {
    methodKind: "unary";
    input: typeof GetUsageRequestSchema;
    output: typeof UsageSchema;
  },
  /**
   * How each agent of an organisation is doing: what it landed day by day, its change
   * requests, failed checks and refused lands (organisation administrators).
   *
   * @generated from rpc gd.v1.Platform.AgentStats
   */
  agentStats: {
    methodKind: "unary";
    input: typeof AgentStatsRequestSchema;
    output: typeof AgentStatsResponseSchema;
  },
  /**
   * What one agent did, session by session: reads, searches, lands (and refusals, with why),
   * change requests, failed checks (organisation administrators, and the person it answers to).
   *
   * @generated from rpc gd.v1.Platform.AgentActivity
   */
  agentActivity: {
    methodKind: "unary";
    input: typeof AgentActivityRequestSchema;
    output: typeof AgentActivityResponseSchema;
  },
  /**
   * Replaces an organisation's limits (not its suspension). Site administrators only.
   *
   * @generated from rpc gd.v1.Platform.SetLimits
   */
  setLimits: {
    methodKind: "unary";
    input: typeof SetLimitsRequestSchema;
    output: typeof OrgLimitsSchema;
  },
  /**
   * A suspended organisation can read but not write. Site administrators only.
   *
   * @generated from rpc gd.v1.Platform.SetSuspended
   */
  setSuspended: {
    methodKind: "unary";
    input: typeof SetSuspendedRequestSchema;
    output: typeof OrgLimitsSchema;
  },
  /**
   * What this server offers: anyone may ask.
   *
   * @generated from rpc gd.v1.Platform.GetCapabilities
   */
  getCapabilities: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof CapabilitiesSchema;
  },
  /**
   * The support licence this server was started with. Site administrators only.
   *
   * @generated from rpc gd.v1.Platform.GetLicense
   */
  getLicense: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof LicenseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd_platform, 0);

/**
 * @generated from service gd.v1.Reviews
 */
export const Reviews: GenService<{
  /**
   * @generated from rpc gd.v1.Reviews.ListChangeRequests
   */
  listChangeRequests: {
    methodKind: "unary";
    input: typeof ListChangeRequestsRequestSchema;
    output: typeof ListChangeRequestsResponseSchema;
  },
  /**
   * Views: attention, open, ready, blocked, agents, mine, drafts, landed, closed.
   *
   * @generated from rpc gd.v1.Reviews.ChangeRequestFacets
   */
  changeRequestFacets: {
    methodKind: "unary";
    input: typeof RepositoryRefSchema;
    output: typeof FacetsSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.GetChangeRequest
   */
  getChangeRequest: {
    methodKind: "unary";
    input: typeof ChangeRequestRefSchema;
    output: typeof ChangeRequestSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.CreateChangeRequest
   */
  createChangeRequest: {
    methodKind: "unary";
    input: typeof CreateChangeRequestRequestSchema;
    output: typeof ChangeRequestSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.UpdateChangeRequest
   */
  updateChangeRequest: {
    methodKind: "unary";
    input: typeof UpdateChangeRequestRequestSchema;
    output: typeof ChangeRequestSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.ListComments
   */
  listComments: {
    methodKind: "unary";
    input: typeof ChangeRequestRefSchema;
    output: typeof ListCommentsResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.AddComment
   */
  addComment: {
    methodKind: "unary";
    input: typeof AddCommentRequestSchema;
    output: typeof CommentSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.EditComment
   */
  editComment: {
    methodKind: "unary";
    input: typeof EditCommentRequestSchema;
    output: typeof CommentSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.ResolveThread
   */
  resolveThread: {
    methodKind: "unary";
    input: typeof ResolveThreadRequestSchema;
    output: typeof CommentSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.SubmitReview
   */
  submitReview: {
    methodKind: "unary";
    input: typeof SubmitReviewRequestSchema;
    output: typeof ChangeRequestSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.Land
   */
  land: {
    methodKind: "unary";
    input: typeof ChangeRequestRefSchema;
    output: typeof LandChangeRequestResponseSchema;
  },
  /**
   * Re-applies the change on the target's tip. Edits that do not overlap what landed since are
   * carried over; otherwise it fails with FAILED_PRECONDITION naming the files that conflict.
   * Approvals made on the old version stop counting when the protection says so.
   * Replays the branch's changes on the target's tip. Files both changed are merged line by
   * line; it fails only where their edits clash (see Conflicts).
   *
   * @generated from rpc gd.v1.Reviews.Rebase
   */
  rebase: {
    methodKind: "unary";
    input: typeof ChangeRequestRefSchema;
    output: typeof ChangeRequestSchema;
  },
  /**
   * Where a change request clashes with its target, file by file: the three versions, and the
   * merge (clean, or with conflict markers where the edits clash).
   *
   * @generated from rpc gd.v1.Reviews.Conflicts
   */
  conflicts: {
    methodKind: "unary";
    input: typeof ChangeRequestRefSchema;
    output: typeof ConflictReportSchema;
  },
  /**
   * Rebases with the clashing files settled: each given in full, or deleted. Files that merge
   * cleanly needn't be given.
   *
   * @generated from rpc gd.v1.Reviews.ResolveConflicts
   */
  resolveConflicts: {
    methodKind: "unary";
    input: typeof ResolveConflictsRequestSchema;
    output: typeof ChangeRequestSchema;
  },
  /**
   * Undoes everything an agent landed on a branch since a time, as one change request (or,
   * with dry_run, says what that would undo). Later changes by others to the same files are
   * kept where they don't overlap; where they do, the file is left as it is and listed.
   *
   * @generated from rpc gd.v1.Reviews.RevertAgent
   */
  revertAgent: {
    methodKind: "unary";
    input: typeof RevertAgentRequestSchema;
    output: typeof RevertPlanSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.ListProtections
   */
  listProtections: {
    methodKind: "unary";
    input: typeof RepositoryRefSchema;
    output: typeof ListProtectionsResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.SetProtection
   */
  setProtection: {
    methodKind: "unary";
    input: typeof ProtectionSchema;
    output: typeof ProtectionSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.DeleteProtection
   */
  deleteProtection: {
    methodKind: "unary";
    input: typeof ProtectionRefSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.ReportCheck
   */
  reportCheck: {
    methodKind: "unary";
    input: typeof ReportCheckRequestSchema;
    output: typeof ChangeRequestSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.Inbox
   */
  inbox: {
    methodKind: "unary";
    input: typeof InboxRequestSchema;
    output: typeof InboxResponseSchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.MarkInbox
   */
  markInbox: {
    methodKind: "unary";
    input: typeof MarkInboxRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc gd.v1.Reviews.ListEvents
   */
  listEvents: {
    methodKind: "unary";
    input: typeof ListEventsRequestSchema;
    output: typeof ListEventsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gd_platform, 1);

